// @ts-nocheck
import React from 'react';
import TiledVideoBackground from './TiledVideoBackground';

const isVideoUrl = (url: string | undefined): boolean => {
    if (!url) return false;
    return url.match(/\.(mp4|webm|ogg|mov|avi)($|\?)/i) !== null;
};

interface SplashScreenProps {
    fadeOut?: boolean;
    loginBgMode?: 'image' | 'color';
    loginBgColor?: string;
    loginBgResolution?: number;
    activeLoginBg?: { url: string; style: string } | null;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({
    fadeOut = false,
    loginBgMode = 'image',
    loginBgColor = '#000000',
    loginBgResolution = 100,
    activeLoginBg = null
}) => {
    return (
        <div 
            id="react-initial-loader" 
            className={`fixed inset-0 flex flex-col items-center justify-center text-[#3b82f6] z-[99999] transition-opacity duration-700 pointer-events-none ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
            style={{ fontFamily: 'sans-serif' }}
        >
            {/* Login Background Slideshow Replica */}
            <div className="absolute inset-0 z-0">
                {loginBgMode === 'color' ? (
                    <div className="absolute inset-0 transition-all duration-700" style={{ backgroundColor: loginBgColor || '#000000' }} />
                ) : isVideoUrl(activeLoginBg?.url) ? (
                    activeLoginBg?.style === 'tile' ? (
                        <TiledVideoBackground
                            src={activeLoginBg.url}
                            resolutionVw={activeLoginBg?.resolution || loginBgResolution || 100}
                        />
                    ) : (
                        <video
                            key={activeLoginBg?.url}
                            src={activeLoginBg?.url}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover z-0"
                        />
                    )
                ) : (
                    <div
                        className="absolute inset-0 z-0"
                        style={{
                            backgroundImage: activeLoginBg?.url ? `url(${activeLoginBg.url})` : 'none',
                            backgroundSize: activeLoginBg?.style === 'tile' ? `${activeLoginBg?.resolution || loginBgResolution || 100}%` : 'cover',
                            backgroundRepeat: activeLoginBg?.style === 'tile' ? 'repeat' : 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    />
                )}
                {/* Overlay vignette to make text legible */}
                <div className="absolute inset-0 bg-black/45 backdrop-blur-[2px] z-[1]" />
            </div>

            {/* Spinner and text */}
            <div className="relative z-10 flex flex-col items-center justify-center">
                <div className="w-10 h-10 border-3 border-slate-800 border-t-blue-500 rounded-full animate-spin"></div>
                <div className="mt-[15px] font-semibold text-sm tracking-widest uppercase text-white drop-shadow-md">INITIALIZING GOODLYFE</div>
                <div className="mt-5 font-mono text-[10px] text-white/70 max-w-[80%] text-center drop-shadow-sm">Finalizing setup...</div>
            </div>
        </div>
    );
};
